import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import type { PackageResponse } from "../../admin/packages/packagesApi";

interface Props {
  readonly packageData: PackageResponse;
  readonly url: string | undefined;
}

const PackageTile: FC<Props> = ({ packageData, url }) => {
  const navigate = useNavigate();
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3.5,
        borderRadius: 1,
        border: "1px solid rgba(13, 110, 253, 0.2)",
        bgcolor: "rgba(13, 110, 253, 0.03)",
        display: "flex",
        flexDirection: "column",

        transition: "box-shadow 0.2s, transform 0.2s",
        mb: 3,
        "&:hover": {
          boxShadow: "0 8px 24px rgba(13, 110, 253, 0.12)",
          transform: "translateY(-2px)",
        },
      }}
    >
      <Stack direction="row" spacing={1} sx={{ mb: 2, alignItems: "center" }}>
        <Inventory2OutlinedIcon color="primary" fontSize="small" />
        <Typography
          variant="subtitle2"
          color="text.secondary"
          sx={{ letterSpacing: 1, fontWeight: "bold", textTransform: "uppercase" }}
        >
          Pakiet źródłowy
        </Typography>
      </Stack>

      <Stack direction="row" spacing={2} sx={{ flexGrow: 1, alignItems: "flex-start" }}>
        <Box
          component="img"
          src={url}
          alt={packageData.name.publicValue}
          sx={{ width: 80, height: 80, borderRadius: 1, objectFit: "cover", flexShrink: 0 }}
        />
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="caption" color="primary" sx={{ fontWeight: "bold" }}>
            ID pakietu #{packageData.id.userFriendlyId ?? packageData.id.id}
          </Typography>
          <Typography variant="subtitle1" sx={{ lineHeight: 1.3, mb: 0.5, fontWeight: "bold" }}>
            {packageData.name.publicValue}
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.45 }}>
            Ta wycieczka powstała na bazie gotowego pakietu. Zobacz pełny program, atrakcje i materiały sprzedażowe.
          </Typography>
        </Box>
      </Stack>

      <Button
        fullWidth
        variant="contained"
        color="primary"
        disableElevation
        sx={{ borderRadius: 2, mt: 3 }}
        endIcon={<OpenInNewIcon fontSize="small" />}
        onClick={() => {
          navigate(`/public/packages/${packageData.id.id}`);
        }}
      >
        Otwórz pakiet
      </Button>
    </Paper>
  );
};

export default PackageTile;
